import { axios } from "@cores/axiosWrapper";

export function getEnginesAPI(stageId, apiEndpoint, projectId, params = {}) {
    return axios.get(`${apiEndpoint}/gen-ai/engines`, {
        params,
        headers: {
            stageId,
            projectId,
        },
    });
}

// Single Prompt
export function getJobsAPI(stageId, apiEndpoint, projectId, params = {}, signal) {
    return axios.get(`${apiEndpoint}/gen-ai/jobs`, {
        params,
        headers: {
            stageId,
            projectId,
        },
        signal,
    });
}

export function getJobDetailAPI(stageId, apiEndpoint, projectId, jobId, params = {}, signal) {
    return axios.get(`${apiEndpoint}/gen-ai/jobs/${jobId}`, {
        params,
        headers: {
            stageId,
            projectId,
        },
        signal,
    });
}

export function updateSourcesAPI(stageId, apiEndpoint, projectId, data) {
    return axios.post(`${apiEndpoint}/gen-ai/sources/actions`, data, {
        headers: {
            stageId,
            projectId,
        },
        customErrorMessage: true,
    });
}

export function getSourceDetailAPI(stageId, apiEndpoint, projectId, sourceId) {
    return axios.get(`${apiEndpoint}/gen-ai/sources/${sourceId}`, {
        headers: {
            stageId,
            projectId,
        },
    });
}

export function createJobsAPI(stageId, apiEndpoint, projectId, data) {
    return axios.post(`${apiEndpoint}/gen-ai/jobs`, data, {
        headers: {
            stageId,
            projectId,
        },
        customErrorMessage: true,
    });
}

export function getJobStatusAPI(stageId, apiEndpoint, projectId, jobId) {
    return axios.get(`${apiEndpoint}/gen-ai/jobs/${jobId}/status`, {
        headers: {
            stageId,
            projectId,
        },
    });
}

// Chat Prompt
export function getSessionsAPI(stageId, apiEndpoint, projectId, params, signal) {
    return axios.get(`${apiEndpoint}/gen-ai/sessions`, {
        params,
        headers: {
            stageId,
            projectId,
        },
        signal,
    });
}

export function createSessionAPI(stageId, apiEndpoint, projectId, data) {
    return axios.post(`${apiEndpoint}/gen-ai/sessions`, data, {
        headers: {
            stageId,
            projectId,
        },
        customErrorMessage: true,
    });
}

export function createSessionChatAPI(stageId, apiEndpoint, projectId, sessionId, data) {
    return axios.post(`${apiEndpoint}/gen-ai/sessions/${sessionId}/chats`, data, {
        headers: {
            stageId,
            projectId,
        },
        customErrorMessage: true,
    });
}

export function getSessionChatsAPI(stageId, apiEndpoint, projectId, sessionId, params = {}, signal) {
    return axios.get(`${apiEndpoint}/gen-ai/sessions/${sessionId}/chats`, {
        params,
        headers: {
            stageId,
            projectId,
        },
        signal,
    });
}

export function retrySessionChatAPI(stageId, apiEndpoint, projectId, sessionId, data) {
    return axios.post(`${apiEndpoint}/gen-ai/sessions/${sessionId}/actions`, data, {
        headers: {
            stageId,
            projectId,
        },
        customErrorMessage: true,
    });
}
